export const updateUserMeta = (data) => (dispatch) => {
  dispatch({
    type: 'APP_SET_USER',
    payload: data,
  });
};
